import { VisitTypeInteractor, VisitTypeRequest, VisitTypeStructRequest } from "../../Coordinator/VisitType/VisitTypeInteractor";

export class VisitTypeViewModel {
	private interactor: VisitTypeInteractor;

	constructor() {
		this.interactor = new VisitTypeInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new VisitTypeRequest(
			obj["sgeptipovisita"] ? parseInt(obj["sgeptipovisita"]) : 0,
			obj["nome"] ? obj["nome"] : "",
			obj["codigo"] ? obj["codigo"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new VisitTypeStructRequest(obj["sgeptipovisita"] ? parseInt(obj["sgeptipovisita"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}